import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, CheckGrid, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { serviceLd } from "../components/site/SEO";
import { HEALTHCARE_SERVICES, HEALTHCARE_DISCLAIMER } from "../data/content";

export default function PatientSupport() {
    return (
        <div className="grain bg-navy-deep" data-testid="patient-support-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "International Patient Support | Viet Medica Ltd",
                        description:
                            "Human, practical support for international patients — coordination, translation, travel, appointments, accommodation and follow-up communication across Asia.",
                        path: "/patient-support",
                        jsonLd: serviceLd(
                            "International Patient Support",
                            "Practical coordination and human support for international patients travelling for healthcare in Asia.",
                            "/patient-support"
                        ),
                    }}
                    crumbs={[{ label: "Healthcare & Medical Tourism", href: "/healthcare-medical-tourism" }, { label: "Patient Support" }]}
                    eyebrow="Healthcare & Medical Tourism"
                    title="International Patient"
                    titleEm="Support."
                    copy="Travelling for healthcare involves more than the treatment itself. Our coordinators support the practical details around your care — communication, documents, travel, appointments and recovery arrangements — so you can focus on your health."
                />

                <PageSection eyebrow="What We Coordinate" title="Practical Support Around Your Care" testid="patient-support-services">
                    <CheckGrid items={HEALTHCARE_SERVICES} cols={3} />
                    <div className="mt-10">
                        <DisclaimerBox text={HEALTHCARE_DISCLAIMER} testid="patient-support-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Speak with a patient coordinator."
                            primary={{ label: "Healthcare Enquiry", to: "/healthcare-enquiry", testid: "support-enquiry-cta" }}
                            secondary={{ label: "How the Journey Works", to: "/patient-journey", testid: "support-journey-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
